import React from 'react';
import PropTypes from 'prop-types';
import {Box, Typography, TextField} from 'views/components';
import {Translate} from 'views/module';

const YourCareBoxEdit = (props) => {
  const {data, updateFormData} = props;

  const handleChange = (field, value) => {
    updateFormData(field, value);
  };

  return (
    <Box style={{background: 'white', borderRadius: '1rem', boxShadow: '0 1px 6px rgba(0,0,0,0.1)', padding: '1rem', position: 'relative'}}>
      <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.5rem'}}>
        <Typography variant="h6">
          <Translate expression="profile.YourCareBox.YourCare" />
        </Typography>
      </Box>

      <Box sx={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', alignItems: 'start'}}>
        {/* Top Left: Name */}
        <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'}}>
          <Typography variant="subtitle2">
            <Translate expression="profile.YourCareBox.CareRecipientName" />
          </Typography>
          <TextField
            value={data.name}
            onChange={(e) => handleChange('name', e)}
            size="small"
            inputProps={{style: {padding: '4px 8px', fontSize: '0.95rem', height: 28}}}
          />
        </Box>

        {/* Top Right: Location */}
        <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'}}>
          <Typography variant="subtitle2">
            <Translate expression="profile.YourCareBox.Location" />
          </Typography>
          <TextField
            value={data.location}
            onChange={(e) => handleChange('location', e)}
            size="small"
            inputProps={{style: {padding: '4px 8px', fontSize: '0.95rem', height: 28}}}
          />
        </Box>

        {/* Bottom Left: Languages */}
        <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'}}>
          <Typography variant="subtitle2">
            <Translate expression="profile.YourCareBox.LanguagesSpoken" />
          </Typography>
          <TextField
            value={typeof data.languages === 'string' ? data.languages : data.languages?.join(', ')}
            onChange={(e) => handleChange('languages', e)}
            size="small"
            inputProps={{style: {padding: '4px 8px', fontSize: '0.95rem', height: 28}}}
          />
        </Box>

        {/* Bottom Right: Start Date */}
        <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'}}>
          <Typography variant="subtitle2">
            <Translate expression="profile.YourCareBox.StartDate" />
          </Typography>
          <TextField
            value={data.startDate}
            onChange={(e) => handleChange('startDate', e)}
            size="small"
            inputProps={{style: {padding: '4px 8px', fontSize: '0.95rem', height: 28}}}
          />
        </Box>
      </Box>
    </Box>
  );
};

YourCareBoxEdit.propTypes = {
  data: PropTypes.object.isRequired,
  updateFormData: PropTypes.func.isRequired,
};

export default YourCareBoxEdit;
